/**
 * Human-readable byte size — the ONE formatter the SPA uses (TaskDetail's
 * attachment list, the /assets gallery). Binary units, one decimal above
 * 1 KB, never a trailing ".0" hidden — the numbers are small and exact.
 */
export function fmtBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
